import(/* webpackMode: "eager" */ "/vercel/path0/src/app/projects/[name]/page.tsx");
